import { defineStore, acceptHMRUpdate } from 'pinia';
import { storeConfig } from '@/shared/storeConfig';

const accountMenuStore = () => {
  const isLoading = ref<boolean>(false);

  const currentMenuOpen = ref<AccountMenu.Item['group'] | null>(null);

  const setCurrentMenuOpen = (group: AccountMenu.Item['group']) => {
    currentMenuOpen.value = group;
  };

  const setCurrentMenuOpenByGroup = (group: AccountMenu.Item['group']) => {
    currentMenuOpen.value = group;
  };

  const resetCurrentMenuOpen = () => {
    currentMenuOpen.value = null;
  };

  return {
    isLoading,
    currentMenuOpen,
    setCurrentMenuOpen,
    setCurrentMenuOpenByGroup,
    resetCurrentMenuOpen,
  };
};

export const useAccountMenuStore = defineStore(
  'accountMenu',
  accountMenuStore,
  storeConfig,
);

// @ts-ignore
if (import.meta.hot) {
  // @ts-ignore
  import.meta.hot.accept(acceptHMRUpdate(useAccountMenuStore, import.meta.hot));
}
